import type { APIClient } from '@src/shared/api';

import { useMutation } from '@src/shared/query';

export type PasswordChangePayload = {
  current_password: string;
  password: string;
};

type PasswordChangeResponse = {
  detail: string;
  access: string;
  refresh: string;
};

type UserPasswordResetResponse = {
  detail: string;
  access?: string;
  refresh?: string;
};

export function usePasswordChange() {
  return useMutation<PasswordChangeResponse, Error, PasswordChangePayload>({
    mutationKey: ['auth', 'password-change'],
    mutateFn: ({
      apiClient,
      ...payload
    }: { apiClient: APIClient } & Record<string, unknown>) => {
      return apiClient.request({
        url: `${import.meta.env.VITE_AUTH_DOMAIN}/api/v1/auth/password/change/`,
        method: 'POST',
        payload,
      }) as Promise<PasswordChangeResponse>;
    },
  });
}

type UserPasswordResetPayload = {
  id: number | string;
  password: string;
};

export function useUserPasswordReset() {
  return useMutation<
    UserPasswordResetResponse,
    Error,
    UserPasswordResetPayload
  >({
    mutationKey: ['users', 'password-reset'],
    mutateFn: ({ apiClient, id, password }) => {
      return apiClient.request({
        url: `users/${String(id)}/password/reset/`,
        method: 'POST',
        payload: { password },
      }) as Promise<UserPasswordResetResponse>;
    },
  });
}
